import React, { Component } from "react"
import config from "react-global-configuration"
import * as tracking from "../../helpers/tracking"
import * as path from "../../constants/Paths"

class ParkingExtraServiceAcceptConditionsModal extends Component {
  static defaultProps = {
    goToNextStepOnSelect: true,
  }

  handleReserveExtra = (product, sku) => {
    //     this.props.extraServiceModalSelectorToogle(this.props.extraProduct)
    this.props.extraServicesAcceptConditionsModalClose(this.props.extraProduct)
    this.props.addExtraToBooking(
      product,
      sku,
      () => this.props.goToNextStepOnSelect && this.props.history.push({ pathname: path.CHECKOUT(), search: this.props.location.search }),
    )
  }

  handleDecline = (eventAction, eventLabel) => {
    tracking.trackParkingFlowClick(eventAction, eventLabel, this.props)
    this.props.extraServicesAcceptConditionsModalCancel()
  }

  handleAccept = (eventAction, eventLabel) => {
    tracking.trackParkingFlowClick(eventAction, eventLabel, this.props)
    this.handleReserveExtra(this.props.extraServiceModalProduct, this.props.extraServiceModalProductSku)
  }

  render() {
    if (!this.props.isActive) return ""

    const textKeys = config.get("textKeys.extraServices.conditionsModal") || {}

    return (
      <div className={"overlay overlay--modal overlay--fixed is-active"}>
        <div className="modal modal--large modal--parking-product-row-modal">
          <div className="modal__content modal__content--no-padding">
            <div className="modal__content__inner">
              <div className="modal__top">
                <header>
                  <h3 className="headline-md">{textKeys.headline || "Acceptér betingelser og vilkår"}</h3>
                  <p>
                    <span
                      dangerouslySetInnerHTML={{
                        __html:
                          textKeys.conditionsText ||
                          'Denne service forhandles og udføres af Københavns Bilpleje Aps med CVR-nr.: 29 83 14 91 og tlf +45 40956337. Ved køb af denne service accepterer du således deres&nbsp;<a href="https://info.parkering.cph.dk/vilk%C3%A5r-kbh-bilpleje" target="_blank">salgs- og leveringsbetingelser.</a>&nbsp;Københavns Lufthavne A/S er ikke aftalepart.&nbsp;',
                      }}
                    ></span>
                  </p>

                  {/* <a className="button button--link"
                                        href={specialProductLink} target="_blank"
                                    >
                                        <span className="text" dangerouslySetInnerHTML={{ __html: decodeURIComponent(specialProductLinkText.toString().replace(/<[^>]*>/g, '')) }}></span>
                                    </a> */}
                </header>
              </div>

              <div className="modal__bottom">
                <footer>
                  <button
                    className="button button--small button--general button--negative"
                    onClick={() => this.handleDecline("extra services", `terms decline - ${this.props.extraProduct.name}`)}
                  >
                    <span className="text">{textKeys.cancel || "Nej tak"}</span>
                  </button>

                  <button
                    className="button button--small button--general "
                    onClick={() => this.handleAccept("extra services", `add - ${this.props.extraProduct.name}`)}
                  >
                    <span className="text">{textKeys.ok || "Acceptér"}</span>
                  </button>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ParkingExtraServiceAcceptConditionsModal
